export const materials = [
    {
        id: 1,
        name: "Առավելագույն ծավալ",
        info: "Դիտել",
        file: "../../files/mathematics/materials/1.pdf",
        menuItemId: 7
    },
    {
        id: 2,
        name: "Արքիմեդի խնդիրը",
        info: "Դիտել",
        file: "../../files/mathematics/materials/2.pdf",
        menuItemId: 7
    },
    {
        id: 3,
        name: "Բազմանիստեր",
        info: "Դիտել",
        file: "../../files/mathematics/materials/3.pdf",
        menuItemId: 7
    },
    {
        id: 4,
        name: "Բաժանելիության հայտանիշներ",
        info: "Դիտել",
        file: "../../files/mathematics/materials/4.pdf",
        menuItemId: 7
    },
    {
        id: 5,
        name: "Բնական թվեր",
        info: "Դիտել",
        file: "../../files/mathematics/materials/5.pdf",
        menuItemId: 7
    },
    {
        id: 6,
        name: "Բնական թվերի վերլուծումը պարզ արտադրիչների",
        info: "Դիտել",
        file: "../../files/mathematics/materials/6.pdf",
        menuItemId: 7
    },
    {
        id: 7,
        name: "Բնական թվի վերլուծումը պարզ արտադրիչների",
        info: "Դիտել",
        file: "../../files/mathematics/materials/7.pdf",
        menuItemId: 7
    },
    {
        id: 8,
        name: "Երկրաչափական անհավասարություններ",
        info: "Դիտել",
        file: "../../files/mathematics/materials/8.pdf",
        menuItemId: 7
    },
    {
        id: 9,
        name: "Էվկլիդեսի խնդիրը",
        info: "Դիտել",
        file: "../../files/mathematics/materials/9.pdf",
        menuItemId: 7
    },
    {
        id: 10,
        name: "Էքստրեմումներ",
        info: "Դիտել",
        file: "../../files/mathematics/materials/10.pdf",
        menuItemId: 7
    },
    {
        id: 11,
        name: "Կեպլերի խնդիրները",
        info: "Դիտել",
        file: "../../files/mathematics/materials/11.pdf",
        menuItemId: 7
    },
    {
        id: 12,
        name: "Կետերի հեռավորությունը կոորդինատներով",
        info: "Դիտել",
        file: "../../files/mathematics/materials/12.pdf",
        menuItemId: 7
    },
    {
        id: 13,
        name: "Կոորդինատային հարթություն",
        info: "Դիտել",
        file: "../../files/mathematics/materials/13.pdf",
        menuItemId: 7
    },
    {
        id: 14,
        name: "Կոորդինատների մեթոդի կիրառությունը խնդիրներ լուծելիս",
        info: "Դիտել",
        file: "../../files/mathematics/materials/14.pdf",
        menuItemId: 7
    },
    {
        id: 15,
        name: "Հատվածի միջնակետի կոորդինատները",
        info: "Դիտել",
        file: "../../files/mathematics/materials/15.pdf",
        menuItemId: 7
    },
    {
        id: 16,
        name: "Հերոնի խնդիրը",
        info: "Դիտել",
        file: "../../files/mathematics/materials/16.pdf",
        menuItemId: 7
    },
    {
        id: 17,
        name: "Մակերես",
        info: "Դիտել",
        file: "../../files/mathematics/materials/17.pdf",
        menuItemId: 7
    },
    {
        id: 18,
        name: "Մասշտաբ–Գործնական",
        info: "Դիտել",
        file: "../../files/mathematics/materials/18.pdf",
        menuItemId: 7
    },
    {
        id: 19,
        name: "Մասշտաբ–տեսություն",
        info: "Դիտել",
        file: "../../files/mathematics/materials/19.pdf",
        menuItemId: 7
    },
    {
        id: 20,
        name: "Նվազագույն մակերես",
        info: "Դիտել",
        file: "../../files/mathematics/materials/20.pdf",
        menuItemId: 7
    },
    {
        id: 21,
        name: "Նվազագույն պարագիծ",
        info: "Դիտել",
        file: "../../files/mathematics/materials/21.pdf",
        menuItemId: 7
    },
    {
        id: 22,
        name: "Պրիզմա",
        info: "Դիտել",
        file: "../../files/mathematics/materials/22.pdf",
        menuItemId: 7
    },
    {
        id: 23,
        name: "Փոխադարձաբար պարզ թվեր",
        info: "Դիտել",
        file: "../../files/mathematics/materials/23.pdf",
        menuItemId: 7
    },


];

